module.exports = __webpack_public_path__ + "static/media/peterArt2.53ca72ee.jpg";